module.exports = __webpack_public_path__ + "img/asian-chicken-broccoli-1.9f05c748.jpg";